import React from "react";
import { useTranslation } from "react-i18next";
import { ImageGrid } from "./ImageGrid";
import { ImageFinderProps } from "./../../types/globals.types";
import styles from "./styles.module.scss";

export const ImageFinder: React.FC<ImageFinderProps> = ({
  images,
  activeImage,
  setActiveImg,
}) => {
  const { t } = useTranslation();
  return (
    <div className={styles.imgFinderContainer}>
      <div className={styles.imgFinderHeader}>{t("clickToSelect")}</div>
      <ImageGrid
        images={images}
        activeImage={activeImage}
        setActiveImg={setActiveImg}
      />
    </div>
  );
};
